import { IJobCategory, IJobPosition, IJobPositionForm } from "./../../auth/models/jobs";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { UtilsService } from "../../auth/service/utils.service";

@Injectable({
  providedIn: "root",
})
export class JobPositionsService {
  public list: IJobPosition[] = [];
  public CategoriesJobPositionslist: IJobCategory[] = [];

  private baseurlJobCategories: string = "/position/category";
  private baseurlJobPositions: string = "/position";

  constructor(
    private _httpClient: HttpClient,
    private _utilService: UtilsService,
  ) {}

  async getListJobPositions() {
    return this._httpClient
      .get(this.baseurlJobPositions)
      .toPromise()
      .then((response: IJobPosition[]) => {
        this.list = response;
        return response;
      })
      .catch((err) => {
        console.error(err);
        return [];
      });
  }
  async getJobPosition(idOrSlug: string | number) {
    return this._httpClient.get<IJobPosition>(`${this.baseurlJobPositions}/${idOrSlug}`).toPromise();
  }
  async getDescriptionFromRequest(id: number) {
    return this._httpClient.get<{ description: string; summary: string }>(`/position/generate/${id}`).toPromise();
  }
  async getCandidature() {
    return this._httpClient
      .get("/candidature")
      .toPromise()
      .then((response: any[]) => {
        return response;
      })
      .catch((err) => {
        console.error(err);
        return [];
      });
  }

  async deleteJobPosition(id: number) {
    return this._httpClient
      .delete(this.baseurlJobPositions + "/" + id)
      .toPromise()
      .then(async (response) => {
        await this.getListJobPositions();
        return response;
      });
  }

  async createJobPosition(data: IJobPositionForm) {
    return this._httpClient
      .post(this.baseurlJobPositions, data)
      .toPromise()
      .then(async (response) => {
        await this.getListJobPositions();
        return response;
      });
  }

  async updateJobPosition(id: number, data: IJobPositionForm) {
    return this._httpClient
      .put(this.baseurlJobPositions + "/" + id, data)
      .toPromise()
      .then(async () => {
        await this.getListJobPositions();
      });
  }

  /*JOB CATEGORIES FUNCTION*/
  async getListJobCategories() {
    return this._httpClient
      .get(this.baseurlJobCategories)
      .toPromise()
      .then((response: IJobCategory[]) => {
        this.CategoriesJobPositionslist = response;
        return response;
      })
      .catch((err) => {
        console.error(err);
        return [];
      });
  }

  async deleteJobCategory(id: number) {
    return this._httpClient
      .delete(this.baseurlJobCategories + "/" + id)
      .toPromise()
      .then(async (response) => {
        await this.getListJobCategories();
        return response;
      });
  }

  async createJobCategory(data: IJobCategory) {
    return this._httpClient
      .post(this.baseurlJobCategories, data)
      .toPromise()
      .then(async (response) => {
        await this.getListJobCategories();
        return response;
      });
  }

  async updateJobCategory(id: number, data: IJobCategory) {
    return this._httpClient
      .put(this.baseurlJobCategories + "/" + id, data)
      .toPromise()
      .then(async () => {
        await this.getListJobCategories();
      });
  }
}
